/* eslint-disable react/require-default-props */
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { AccountRecruitingUsageType, VIEW_MODE } from '../../consts/enums';
import CustomSelect from '../CustomSelect';

export type RecruitingTypeSelectProps = {
  value?: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  viewMode?: ViewMode;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
};

const RecruitingTypeSelect = ({
  value,
  onChange,
  error = false,
  helperText = '',
  viewMode = VIEW_MODE.EDITABLE,
  name = 'recruitingUsageType',
  disabled = false,
  required = false,
  fullWidth = true,
}: RecruitingTypeSelectProps): JSX.Element => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;
  const variantType = isReadOnly ? 'standard' : 'outlined';

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl
      fullWidth={ fullWidth }
      error={ error }
      variant={ variantType }
      margin="normal"
      required={ required }
    >
      <InputLabel id="recruitingUsageType-label">Recruiting Type</InputLabel>
      <CustomSelect
        label="Recruiting Type"
        labelId="recruitingUsageType-label"
        value={ value || '' }
        error={ error }
        name={ name }
        viewMode={ viewMode }
        disabled={ disabled }
        onChange={ handleChange }
      >
        {Object.entries(AccountRecruitingUsageType).map(([key, enumValue]) => (
          <MenuItem key={ key } value={ enumValue }>
            {enumValue}
          </MenuItem>
        ))}
      </CustomSelect>
      {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default RecruitingTypeSelect;
